<template>
<li id="view-reports">
    <a href="/reports/"><i class="fa fa-bar-chart-o"></i> Berichte</a>
    <div class="grid-container3">
        <ul>
            <li><a href="/reports/daily-accounting/"><i class="fa fa-calculator"></i> Tagesabrechnung</a></li>
            <li><a href="/reports/bookings/hours/"><i class="fa fa-bar-chart-o"></i> Auslastung Venues</a></li>
            <li><a href="/reports/bookings/origin/"><i class="fa fa-bar-chart-o"></i> Buchungs-Herkunft</a></li>
            <li><a href="/customers/status/sales_lead/"><i class="fa fa-address-book-o"></i> Interessenten</a></li>
            <li><a href="/reports/onlinepayments/"><i class="fa fa-folder-open-o"></i> Online-Zahlungen</a></li>
            <li><a href="/reports/outstandings/"><i class="fa fa-exclamation-circle"></i> Offene Zahlungen</a></li>
            <li><a href="/reports/accountingbalances/"><i class="fa fa-area-chart"></i> Kunden-Saldi</a></li>
            <li><a href="/reports/cashouts/"><i class="fa fa-money"></i> Auszahlungen</a></li>
            <li><a href="/reports/staff/"><i class="fa fa-address-card-o"></i> Schulwartabrechnung</a></li>
            <li><a href="/reports/custom/balanceexport/"><i class="fa fa-table"></i>Weitere Berichte</a></li>
            <li><a href="/reports/custom/courseibanexport/"><i class="fa fa-table"></i>Weitere Berichte</a></li>
            <li><a href="/reports/sharedbookings/"><i class="fa fa-list-alt"></i><?php echo $this->customizer->getPlural('sharedbooking'); ?></a></li>
            <li><a href="/reports/sharedbookings/dailyclosingexport/"><i class="fa fa-file"></i>Auswertungen</a></li>
        </ul>
    </div>
</li>
</template>

<script>
export default {
    //
}
</script>
